import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataSecurityApplicationsAllSlice } from './get';

export const coreDataSecurityApplicationsAllReducers = combineReducers({
	get: getCoreDataSecurityApplicationsAllSlice.asyncReducers
});

export const coreDataSecurityApplicationsAllWatchers = combineAllWatchers([
	getCoreDataSecurityApplicationsAllSlice.asyncWatchers
]);
